import React, { useEffect, useState, useRef } from 'react';
import { LeafIcon, DropletIcon, MoonIcon, CheckIcon, ArrowRightIcon, ShieldCheckIcon, DownloadIcon, FlaskConicalIcon, XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  const privacy = <>
      <h2 style={{
      fontFamily: 'var(--font-heading)',
      fontWeight: 500
    }} className="text-3xl mb-6" data-id="element-2">
        Política de Privacidad
      </h2>
      <div className="space-y-4 text-sm leading-relaxed" style={{
      opacity: 0.85
    }} data-id="element-3">
        <p data-id="element-4">
          <strong data-id="element-5">Última actualización:</strong> febrero 2026
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-6">
          1. Responsable del tratamiento
        </h3>
        <p data-id="element-7">
          Protocolo Reinicio Hormonal es responsable del tratamiento de los
          datos personales que nos facilites a través de esta página web.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-8">
          2. Datos que recopilamos
        </h3>
        <p data-id="element-9">
          Únicamente recopilamos los datos necesarios para procesar tu compra:
          nombre, dirección de correo electrónico y datos de pago (gestionados
          de forma segura por nuestro proveedor de pagos). No almacenamos datos
          de tarjetas de crédito.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-10">
          3. Finalidad del tratamiento
        </h3>
        <p data-id="element-11">
          Tus datos se utilizan exclusivamente para: (a) procesar y entregar tu
          pedido, (b) enviarte la confirmación de compra y el enlace de
          descarga, y (c) atender consultas relacionadas con tu compra.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-12">
          4. Conservación de datos
        </h3>
        <p data-id="element-13">
          Conservamos tus datos durante el tiempo necesario para cumplir con las
          obligaciones legales y contables aplicables, generalmente no más de 5
          años.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-14">5. Tus derechos</h3>
        <p data-id="element-15">
          Tienes derecho a acceder, rectificar, suprimir, limitar u oponerte al
          tratamiento de tus datos personales. Para ejercer estos derechos,
          puedes contactarnos por correo electrónico.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-16">6. Seguridad</h3>
        <p data-id="element-17">
          Aplicamos medidas técnicas y organizativas adecuadas para proteger tus
          datos personales contra el acceso no autorizado, la pérdida o la
          divulgación.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-18">7. Cookies</h3>
        <p data-id="element-19">
          Esta página puede utilizar cookies técnicas necesarias para su
          funcionamiento. No utilizamos cookies de seguimiento ni publicidad de
          terceros.
        </p>
      </div>
    </>;
  const terms = <>
      <h2 style={{
      fontFamily: 'var(--font-heading)',
      fontWeight: 500
    }} className="text-3xl mb-6" data-id="element-20">
        Aviso Legal y Términos de Uso
      </h2>
      <div className="space-y-4 text-sm leading-relaxed" style={{
      opacity: 0.85
    }} data-id="element-21">
        <p data-id="element-22">
          <strong data-id="element-23">Última actualización:</strong> febrero 2026
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-24">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-25">
          El Protocolo Reinicio Hormonal es una guía informativa en formato
          digital (PDF). Su contenido tiene carácter educativo y divulgativo, y
          no constituye consejo médico, diagnóstico ni tratamiento de ninguna
          enfermedad o condición de salud.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-26">2. Aviso de salud</h3>
        <p data-id="element-27">
          Consulta siempre con un profesional de la salud cualificado antes de
          realizar cambios significativos en tu alimentación o estilo de vida,
          especialmente si tienes condiciones médicas preexistentes o tomas
          medicación.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-28">3. Resultados</h3>
        <p data-id="element-29">
          Los resultados descritos son orientativos y pueden variar según cada
          persona. No garantizamos resultados específicos derivados del uso de
          esta guía.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-30">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-31">
          Todo el contenido de esta guía (textos, diseño, estructura) es
          propiedad exclusiva de Protocolo Reinicio Hormonal. Queda prohibida su
          reproducción, distribución o venta sin autorización expresa por
          escrito.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-32">
          5. Política de reembolso
        </h3>
        <p data-id="element-33">
          Dado que se trata de un producto digital de descarga inmediata, no se
          admiten devoluciones una vez realizada la descarga, salvo en los casos
          previstos por la legislación vigente de protección al consumidor.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-34">
          6. Legislación aplicable
        </h3>
        <p data-id="element-35">
          Estos términos se rigen por la legislación española vigente. Cualquier
          controversia se someterá a los juzgados y tribunales competentes.
        </p>
      </div>
    </>;
  return <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-0 md:p-6" style={{
    backgroundColor: 'rgba(28,28,28,0.5)',
    backdropFilter: 'blur(4px)'
  }} onClick={onClose} data-id="element-36">
      <div className="relative w-full md:max-w-2xl max-h-[85vh] overflow-y-auto rounded-t-3xl md:rounded-3xl p-8 md:p-10" style={{
      backgroundColor: 'var(--color-cream)',
      color: 'var(--color-charcoal)'
    }} onClick={e => e.stopPropagation()} data-id="element-37">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-full transition-colors" style={{
        backgroundColor: 'var(--color-cream-dark)'
      }} aria-label="Cerrar" data-id="element-38">
          <XIcon className="w-4 h-4" style={{
          color: 'var(--color-charcoal)'
        }} data-id="element-39" />
        </button>

        {type === 'privacy' ? privacy : terms}
      </div>
    </div>;
}
function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  const {
    ref,
    inView
  } = useInView();
  return <div ref={ref} className={className} style={{
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(28px)',
    transition: `opacity 0.7s ease ${delay}ms, transform 0.7s ease ${delay}ms`
  }} data-id="element-40">
      {children}
    </div>;
}
export function SalesPage() {
  const [modal, setModal] = useState<ModalType>(null);
  return <main className="min-h-screen w-full" style={{
    backgroundColor: 'var(--color-cream)',
    fontFamily: 'var(--font-body)',
    color: 'var(--color-charcoal)'
  }} data-id="element-41">
      {/* Top Bar */}
      <div className="w-full py-3 text-center text-xs tracking-[0.25em] uppercase" style={{
      borderBottom: '1px solid var(--color-border)',
      opacity: 0.6
    }} data-id="element-42">
        Protocolo Reinicio Hormonal · Guía Digital
      </div>

      {/* ── HERO ── */}
      <section className="w-full px-6 py-16 md:py-28" data-id="element-43">
        <div className="max-w-4xl mx-auto text-center" data-id="element-44">
          <FadeIn data-id="element-45">
            <p className="text-xs tracking-[0.3em] uppercase mb-6" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-46">
              Para mujeres de 40+
            </p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-47">
              Tu cuerpo no está fallando.
              <br data-id="element-48" />
              <em style={{
              color: 'var(--color-sage)',
              fontStyle: 'italic'
            }} data-id="element-49">
                Está pidiendo un reset.
              </em>
            </h1>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-12 leading-relaxed" style={{
            opacity: 0.75
          }} data-id="element-50">
              Una guía práctica de 21 días para recuperar energía, claridad
              mental y bienestar hormonal — sin fármacos ni dietas imposibles.
            </p>
          </FadeIn>

          <FadeIn delay={150} data-id="element-51">
            <div className="relative inline-block mb-12" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/5mLAKnpdhDAwp3mbDu76ac/heylloyd-image-1771522687649.png" alt="Protocolo Reinicio Hormonal - Guía digital" className="mx-auto max-w-xs md:max-w-sm w-full" style={{
              filter: 'drop-shadow(0 30px 60px rgba(0,0,0,0.18))'
            }} data-id="element-53" />
            </div>
          </FadeIn>

          <FadeIn delay={250} data-id="element-54">
            <a href="https://www.tubienestarinterno.com/cart/53097347154257:1" target="_blank" rel="noopener noreferrer" data-id="element-55">
              <button className="inline-flex items-center gap-3 px-10 py-5 text-lg font-medium text-white rounded-full mb-6" style={{
              backgroundColor: 'var(--color-terracotta)',
              boxShadow: '0 8px 30px rgba(196,149,106,0.4)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }} onMouseEnter={e => {
              ;
              (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.04)';
              (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 12px 40px rgba(196,149,106,0.5)';
            }} onMouseLeave={e => {
              ;
              (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
              (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 30px rgba(196,149,106,0.4)';
            }} data-id="element-56">
                Quiero mi guía por 7€
                <ArrowRightIcon className="w-5 h-5" data-id="element-57" />
              </button>
            </a>
            <div className="flex flex-wrap justify-center gap-6 text-sm" style={{
            opacity: 0.55
          }} data-id="element-58">
              <span className="flex items-center gap-2" data-id="element-59">
                <DownloadIcon className="w-4 h-4" data-id="element-60" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-2" data-id="element-61">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-62" /> Pago seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-63">
                <FlaskConicalIcon className="w-4 h-4" data-id="element-64" /> Solo 7€
              </span>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── EMOTIONAL HOOK ── */}
      <section className="w-full px-6 py-16 md:py-20" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-65">
        <div className="max-w-4xl mx-auto" data-id="element-66">
          <FadeIn data-id="element-67">
            <p className="text-2xl md:text-3xl lg:text-4xl text-center italic leading-relaxed mb-16" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 400
          }} data-id="element-68">
              "Te levantas cada mañana con una batalla silenciosa..."
            </p>
          </FadeIn>

          <div className="grid md:grid-cols-3 gap-5 mb-14" data-id="element-69">
            {[{
            icon: <LeafIcon className="w-6 h-6" data-id="element-70" />,
            text: 'Neblina mental que ralentiza tus ideas'
          }, {
            icon: <DropletIcon className="w-6 h-6" data-id="element-71" />,
            text: 'Inflamación en el vientre que no se va'
          }, {
            icon: <MoonIcon className="w-6 h-6" data-id="element-72" />,
            text: 'Cansancio que se ha vuelto tu compañero constante'
          }].map((item, i) => <FadeIn key={i} delay={i * 100} data-id="element-73">
                <div className="p-7 rounded-2xl text-center h-full" style={{
              backgroundColor: 'var(--color-cream)',
              border: '2px solid var(--color-border)'
            }} data-id="element-74">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center" style={{
                backgroundColor: 'rgba(143,175,138,0.15)',
                color: 'var(--color-sage)'
              }} data-id="element-75">
                    {item.icon}
                  </div>
                  <p className="text-base leading-relaxed" data-id="element-76">{item.text}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn data-id="element-77">
            <p className="text-xl md:text-2xl text-center" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 400
          }} data-id="element-78">
              Te han dicho que es normal. Te han dicho que "es la edad".
              <br data-id="element-79" />
              <strong style={{
              color: 'var(--color-terracotta)',
              fontWeight: 600
            }} data-id="element-80">
                Pero sabes dentro de ti que hay algo más.
              </strong>
            </p>
          </FadeIn>
        </div>
      </section>

      {/* ── ROOT CAUSE ── */}
      <section className="w-full px-6 py-16 md:py-24" data-id="element-81">
        <div className="max-w-3xl mx-auto" data-id="element-82">
          <FadeIn data-id="element-83">
            <h2 className="text-4xl md:text-5xl text-center mb-6" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-84">
              No es tu culpa.
              <br data-id="element-85" />
              <em style={{
              color: 'var(--color-sage)'
            }} data-id="element-86">
                Es tu biología.
              </em>
            </h2>
            <p className="text-lg leading-relaxed mb-4 text-center" style={{
            opacity: 0.8
          }} data-id="element-87">
              A partir de los 40, tu cuerpo entra en una nueva etapa hormonal.
              El cortisol sube, los estrógenos bajan y el metabolismo cambia.
              Las dietas de siempre y las rutinas agotadoras solo empeoran la
              situación.
            </p>
          </FadeIn>

          <div className="w-16 h-px mx-auto my-12" style={{
          backgroundColor: 'var(--color-border)'
        }} data-id="element-88" />

          <FadeIn data-id="element-89">
            <h3 className="text-2xl md:text-3xl text-center mb-8" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-90">
              Por qué lo que probaste falló
            </h3>
          </FadeIn>

          <div className="space-y-4 max-w-xl mx-auto" data-id="element-91">
            {[{
            myth: 'Comer menos',
            truth: 'Tu cuerpo lo interpreta como estrés y retiene más grasa.'
          }, {
            myth: 'Correr más',
            truth: 'Eleva aún más tu cortisol, empeorando el desequilibrio.'
          }, {
            myth: 'Dietas restrictivas',
            truth: 'Aumentan la inflamación y agotan tus reservas hormonales.'
          }].map((item, i) => <FadeIn key={i} delay={i * 80} data-id="element-92">
                <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
              backgroundColor: 'var(--color-cream-dark)'
            }} data-id="element-93">
                  <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center" style={{
                backgroundColor: 'rgba(196,149,106,0.15)'
              }} data-id="element-94">
                    <XIcon className="w-4 h-4" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-95" />
                  </div>
                  <div data-id="element-96">
                    <p className="font-semibold mb-1" style={{
                  textDecoration: 'line-through',
                  opacity: 0.5
                }} data-id="element-97">
                      {item.myth}
                    </p>
                    <p className="text-sm leading-relaxed" style={{
                  opacity: 0.8
                }} data-id="element-98">
                      {item.truth}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={100} data-id="element-99">
            <p className="text-2xl md:text-3xl text-center mt-12" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500,
            color: 'var(--color-sage)'
          }} data-id="element-100">
              Lo que necesitas es un reset biológico,
              <br data-id="element-101" />
              no una dieta más.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* ── SOLUTION ── */}
      <section className="w-full px-6 py-16 md:py-24" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-102">
        <div className="max-w-4xl mx-auto" data-id="element-103">
          <FadeIn data-id="element-104">
            <p className="text-xs tracking-[0.3em] uppercase text-center mb-3" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-105">
              La solución
            </p>
            <h2 className="text-4xl md:text-5xl text-center mb-3" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-106">
              Protocolo Reinicio Hormonal
            </h2>
            <p className="text-lg text-center italic mb-12" style={{
            fontFamily: 'var(--font-heading)',
            opacity: 0.7
          }} data-id="element-107">
              21 días · Nutrición anti-inflamatoria · Adaptógenos naturales
            </p>
          </FadeIn>

          <div className="grid md:grid-cols-2 gap-3 max-w-2xl mx-auto mb-12" data-id="element-108">
            {['Plan de alimentación anti-inflamatoria de 21 días', 'Guía de adaptógenos naturales (disponibles en tu supermercado)', 'Protocolo de descanso y gestión del cortisol', 'Lista de compras semanal lista para usar', 'Recetas simples, deliciosas y efectivas', 'Sin fármacos, sin productos caros, sin complicaciones'].map((item, i) => <FadeIn key={i} delay={i * 60} data-id="element-109">
                <div className="flex items-start gap-3 p-4 rounded-xl" style={{
              backgroundColor: 'var(--color-cream)'
            }} data-id="element-110">
                  <CheckIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: 'var(--color-sage)'
              }} data-id="element-111" />
                  <span className="text-sm leading-relaxed" data-id="element-112">{item}</span>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn data-id="element-113">
            <div className="text-center" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/5mLAKnpdhDAwp3mbDu76ac/heylloyd-image-1771522687649.png" alt="Protocolo Reinicio Hormonal" className="mx-auto w-44 md:w-52" style={{
              filter: 'drop-shadow(0 15px 35px rgba(0,0,0,0.12))'
            }} data-id="element-115" />
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── SCIENCE / WHY NOW ── */}
      <section className="w-full px-6 py-16 md:py-24" data-id="element-116">
        <div className="max-w-4xl mx-auto" data-id="element-117">
          <FadeIn data-id="element-118">
            <p className="text-xs tracking-[0.3em] uppercase text-center mb-3" style={{
            color: 'var(--color-sage)'
          }} data-id="element-119">
              Respaldado por la ciencia
            </p>
            <h2 className="text-4xl md:text-5xl text-center mb-4" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-120">
              Por qué funciona ahora
            </h2>
            <p className="text-lg text-center max-w-2xl mx-auto mb-14" style={{
            opacity: 0.75
          }} data-id="element-121">
              La ciencia de la inflamación hormonal ha avanzado. Sabemos
              exactamente cómo usar alimentos y suplementos simples para
              equilibrar tu química interna.
            </p>
          </FadeIn>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-122">
            {[{
            stat: '73%',
            label: 'de mujeres mayores de 40 sufren inflamación crónica de bajo grado sin saberlo'
          }, {
            stat: '28%',
            label: 'de reducción del cortisol documentada con el uso correcto de adaptógenos naturales'
          }, {
            stat: '21 días',
            label: 'es el tiempo mínimo para reprogramar hábitos metabólicos y ver cambios reales'
          }].map((item, i) => <FadeIn key={i} delay={i * 100} data-id="element-123">
                <div className="p-7 rounded-2xl text-center" style={{
              backgroundColor: 'var(--color-cream-dark)',
              border: '1px solid var(--color-border)'
            }} data-id="element-124">
                  <p className="text-4xl md:text-5xl mb-3" style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 600,
                color: 'var(--color-sage)'
              }} data-id="element-125">
                    {item.stat}
                  </p>
                  <p className="text-sm leading-relaxed" style={{
                opacity: 0.75
              }} data-id="element-126">
                    {item.label}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={100} data-id="element-127">
            <p className="text-xs text-center mt-8" style={{
            opacity: 0.4
          }} data-id="element-128">
              Los resultados pueden variar. Esta guía es informativa y no
              reemplaza el consejo médico profesional.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* ── FINAL OFFER ── */}
      <section id="oferta" className="w-full px-6 py-20 md:py-28" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-129">
        <div className="max-w-2xl mx-auto text-center" data-id="element-130">
          <FadeIn data-id="element-131">
            <p className="text-xs tracking-[0.3em] uppercase mb-4" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-132">
              Inversión en tu bienestar
            </p>
            <p className="text-lg mb-2" style={{
            opacity: 0.45,
            textDecoration: 'line-through',
            fontFamily: 'var(--font-heading)'
          }} data-id="element-133">
              Valor real: 47€
            </p>
            <p className="text-8xl md:text-9xl leading-none mb-4" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 600,
            color: 'var(--color-charcoal)'
          }} data-id="element-134">
              7€
            </p>
            <p className="text-lg mb-10" style={{
            fontFamily: 'var(--font-heading)',
            fontStyle: 'italic',
            opacity: 0.7
          }} data-id="element-135">
              Por menos de lo que cuesta un café especial o una revista
            </p>
          </FadeIn>

          <FadeIn delay={100} data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/5mLAKnpdhDAwp3mbDu76ac/heylloyd-image-1771522687649.png" alt="Protocolo Reinicio Hormonal" className="mx-auto w-40 md:w-48 mb-10" style={{
            filter: 'drop-shadow(0 15px 35px rgba(0,0,0,0.12))'
          }} data-id="element-137" />
          </FadeIn>

          <FadeIn delay={150} data-id="element-138">
            <a href="https://www.tubienestarinterno.com/cart/53097347154257:1" target="_blank" rel="noopener noreferrer" data-id="element-139">
              <button className="w-full md:w-auto inline-flex items-center justify-center gap-3 px-12 py-5 text-lg font-medium text-white rounded-full mb-8" style={{
              backgroundColor: 'var(--color-terracotta)',
              boxShadow: '0 8px 30px rgba(196,149,106,0.45)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }} onMouseEnter={e => {
              ;
              (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.04)';
              (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 14px 45px rgba(196,149,106,0.55)';
            }} onMouseLeave={e => {
              ;
              (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
              (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 30px rgba(196,149,106,0.45)';
            }} data-id="element-140">
                Sí, quiero el Protocolo Reinicio Hormonal
                <ArrowRightIcon className="w-5 h-5" data-id="element-141" />
              </button>
            </a>
            <div className="flex flex-wrap justify-center gap-6 text-sm" style={{
            opacity: 0.55
          }} data-id="element-142">
              <span className="flex items-center gap-2" data-id="element-143">
                <DownloadIcon className="w-4 h-4" data-id="element-144" /> Descarga inmediata en PDF
              </span>
              <span className="flex items-center gap-2" data-id="element-145">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-146" /> Pago 100% seguro
              </span>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="w-full px-6 py-8 text-center text-xs" style={{
      borderTop: '1px solid var(--color-border)'
    }} data-id="element-147">
        <p className="mb-3" style={{
        opacity: 0.45
      }} data-id="element-148">
          © 2026 Protocolo Reinicio Hormonal · Todos los derechos reservados
        </p>
        <p className="mb-3" style={{
        opacity: 0.4
      }} data-id="element-149">
          Esta guía es informativa y no constituye consejo médico. Los
          resultados pueden variar.
        </p>
        <div className="flex justify-center gap-6" data-id="element-150">
          <button onClick={() => setModal('privacy')} className="underline underline-offset-2 transition-opacity hover:opacity-100" style={{
          opacity: 0.5,
          fontFamily: 'var(--font-body)'
        }} data-id="element-151">
            Política de Privacidad
          </button>
          <button onClick={() => setModal('terms')} className="underline underline-offset-2 transition-opacity hover:opacity-100" style={{
          opacity: 0.5,
          fontFamily: 'var(--font-body)'
        }} data-id="element-152">
            Aviso Legal
          </button>
        </div>
      </footer>

      {/* ── LEGAL MODAL ── */}
      {modal && <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-153" />}
    </main>;
}